// * MUI Components
import { Box, Container, Typography, TextField, Button, styled } from "@mui/material";
import { Email, Send, CheckCircle } from "@mui/icons-material";
import { useState } from "react";

// * Styled Components
const WaitlistContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: theme.spacing(10, 2),
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(6, 2),
  },
}));

const FormBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  width: "100%",
  maxWidth: "500px",
  marginTop: theme.spacing(4),
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    backgroundColor: "#FFFFFF",
    "& fieldset": {
      borderColor: "#E6F0FF",
    },
    "&:hover fieldset": {
      borderColor: "#3370FF",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#3370FF",
    },
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#3370FF",
  color: "#FFFFFF",
  padding: theme.spacing(1.5, 4),
  borderRadius: 8,
  fontWeight: 600,
  fontSize: "16px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#2756CC",
  },
}));

export default function Waitlist() {
  const [email, setEmail] = useState("");
  const [interest, setInterest] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create hidden iframe
    const iframe = document.createElement('iframe');
    iframe.name = 'hidden_iframe';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Create form
    const form = document.createElement('form');
    form.target = 'hidden_iframe';
    form.method = 'POST';
    form.action = 'https://docs.google.com/forms/d/e/1FAIpQLSePxA9pO93XyMJTUG3pUpWXi_lVXKS3vyX_JBLMoQXhLZMbJg/formResponse';

    // Add email field
    const emailInput = document.createElement('input');
    emailInput.type = 'hidden';
    emailInput.name = 'entry.238951769';
    emailInput.value = email;
    form.appendChild(emailInput);

    // Add interest field
    const interestInput = document.createElement('input');
    interestInput.type = 'hidden';
    interestInput.name = 'entry.742394071';
    interestInput.value = interest;
    form.appendChild(interestInput);

    // Submit
    document.body.appendChild(form);
    form.submit();

    // Clean up and show success
    setTimeout(() => {
      document.body.removeChild(form);
      document.body.removeChild(iframe);
      setEmail("");
      setInterest("");
      setIsSubmitting(false);
      setSubmitted(true);
    }, 1000);
  };

  return (
    <Box sx={{ backgroundColor: "transparent", py: 4 }}>
      <WaitlistContainer>
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #3370FF 0%, #4318FF 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <Email sx={{ fontSize: 50, color: "#FFFFFF" }} />
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontSize: "40px",
            fontWeight: "bold",
            color: "#2B3674",
            mb: 2,
          }}
        >
          Join the Waitlist
        </Typography>

        <Typography
          sx={{
            fontSize: "18px",
            color: "#4A5568",
            maxWidth: "600px",
            mb: 1,
          }}
        >
          Be among the first to experience automated money management.
        </Typography>

        {!submitted ? (
          <>
            <Typography
              sx={{
                fontSize: "16px",
                color: "#3370FF",
                fontWeight: 600,
                mb: 2,
              }}
            >
              Get early access and help shape the future of Dizpurse.
            </Typography>

            <FormBox component="form" onSubmit={handleSubmit}>
          <StyledTextField
            fullWidth
            label="Email Address"
            variant="outlined"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />

          <StyledTextField
            fullWidth
            label="Why are you interested in Dizpurse? (Optional)"
            variant="outlined"
            multiline
            rows={3}
            value={interest}
            onChange={(e) => setInterest(e.target.value)}
            placeholder="Tell us what brings you here..."
          />

          <StyledButton
            type="submit"
            variant="contained"
            endIcon={<Send />}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Join the Waitlist"}
          </StyledButton>
        </FormBox>

        <Typography
          sx={{
            fontSize: "14px",
            color: "#4A5568",
            mt: 4,
          }}
        >
          We respect your privacy. Unsubscribe at any time.
        </Typography>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 4,
            }}
          >
            <CheckCircle
              sx={{
                fontSize: 80,
                color: "#10B981",
                mb: 3,
              }}
            />
            <Typography
              variant="h4"
              sx={{
                fontSize: "32px",
                fontWeight: "bold",
                color: "#2B3674",
                mb: 2,
              }}
            >
              You're on the waitlist!
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                color: "#4A5568",
                textAlign: "center",
                maxWidth: "500px",
              }}
            >
              We'll be in touch soon with early access to Dizpurse.
            </Typography>
          </Box>
        )}
      </WaitlistContainer>
    </Box>
  );
}
